import { useContext } from 'react';
import { ErrorMonitorContext } from './ErrorMonitorProvider';
export var useErrorMonitor = function () {
    var errorMonitor = useContext(ErrorMonitorContext);
    if (!errorMonitor) {
        throw new Error('useErrorMonitor() cannot be used without an <ErrorMonitorProvider>');
    }
    return errorMonitor;
};
//# sourceMappingURL=useErrorMonitor.js.map